query totalPastas($gcpjDesatualizado: Boolean, $where: PastaModelFilterInput) {
    data: pastasOffsetPagination(
        gcpjDesatualizado: $gcpjDesatualizado
        where: $where) {
        totalCount
    }
}